import React from 'react';
import { createUploadMethod } from '../CreateUploadMethod';

export const UploadMethodComponent = ({
    method: { component: Component, props },
    close, onUpload
}: Props) => {

    const onChange = (...args: any[]) => {

        if (props.closeOnUpload) {
            close();
        }

        onUpload && onUpload();
        props.onChange(...args);
    };

    return <Component {...props} onChange={onChange} />;
};

type Props = {
    method: ReturnType<typeof createUploadMethod>;
    close: () => void;
    onUpload?: () => void;
};